import React from 'react';
import { Paper, Stack, Box, Typography } from '@mui/material';
import { DealReasonForLoss, DealStage } from '../../../../utils/enums';
import { format } from 'date-fns';
import { Link } from "react-router-dom";

const BasicDetails = ({ data }) => {

    // if (!data) {
    //     // Display a loading indicator or a message if data is not available
    //     return (
    //         <Paper elevation={0} sx={{ p: 2, textAlign: 'center' }}>
    //             {/* <CircularProgress /> */}
    //             <Typography variant="body2">Loading data...</Typography>
    //         </Paper>
    //     );
    // }

    return (
        <Paper elevation={0} sx={{ p: 2 }}>
            <Stack direction="column" alignItems="center" spacing={2}>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Deal Owner:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.ownerName || '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Contact Name:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>
                            {data?.contactId ? <Link to={`${'/contacts'}/${data?.contactId}`}>{data?.contactName}</Link> : data?.contactName || '—'}
                        </span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Stage:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{DealStage[data?.stage]?.label ?? '—'}</span>
                    </Box>
                </Box>
                {(data?.stage === 7 || data?.stage === 8) &&
                    <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                        <Box display="flex" justifyContent="flex-end" width="40%">
                            <span>Reason for Loss:</span>
                        </Box>
                        <Box display="flex" justifyContent="flex-start" width="60%">
                            <span style={{ marginLeft: '20px' }}>{DealReasonForLoss[data?.reasonForLoss]?.label ?? '—'}</span>
                        </Box>
                    </Box>
                }
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Probability (%):</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.probability || '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Expected Revenue:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>$ {data?.expectedRevenue?.toFixed(2) ?? '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Closing Date:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.closingDate ? format(new Date(data.closingDate), 'MMMM do yyyy') : '—'}</span>
                    </Box>
                </Box>
            </Stack>
        </Paper>
    )
}

export default BasicDetails;